<template>
  <v-card class="mt-2 ml-2 mr-2">
    <FUmkmObjectMain></FUmkmObjectMain>
  </v-card>
</template>
<script>

import FUmkmObjectMain from "@/components/user-umkm-object/FUmkmObjectMain.vue";

export default {
  name: "UserUmkmProfileView",
  components: {
    FUmkmObjectMain
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {

  },


}
</script>

<style scoped>
</style>